import React, { useEffect, useRef, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, LinkIcon } from "lucide-react";

/** ImageInput – primary Image URL text, optional file upload → returns absolute URL to caller. */
export default function ImageInput({ value, onChange, testId }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", f);
      const { data } = await api.post("/files/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const absoluteUrl = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
      onChange(absoluteUrl);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-2">
      <div className="relative flex-1">
        <LinkIcon size={13} className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          data-testid={testId}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://..."
          className="w-full h-8 pl-7 pr-2 text-[13px] border border-slate-200 rounded-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
        />
      </div>
      <label className="h-8 px-2 flex items-center gap-1 text-[12px] border border-slate-200 rounded-sm cursor-pointer hover:bg-slate-50 whitespace-nowrap">
        <Upload size={13} />
        {uploading ? "…" : "Upload"}
        <input ref={inputRef} type="file" accept="image/*" onChange={onFile} className="hidden" />
      </label>
      {value && (
        <img referrerPolicy="no-referrer" src={value} alt="thumbnail" className="w-8 h-8 object-cover border border-slate-200 rounded-sm" />
      )}
    </div>
  );
}
